// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ServiceAreasPage from "../pages/ServiceAreas/ServiceAreas";
const __wvcRoutePaths = ["/ServiceAreasPage", "/service-areas"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["ant-control", "antcontrolpage", "blog", "blogpage", "cary-nc-pest-control", "caryncpestcontrolpage", "cockroach-control", "cockroachcontrolpage", "commercial-pest-control", "commercialpestcontrol", "contact", "contactpage", "customer-portal", "customerportalpage", "flea-tick-control", "fleaandtickcontrolpage", "general-pest-control", "generalpestcontrolpage", "home", "homepage", "mosquito-control", "mosquitocontrolpage", "pest-control-in-chapel-hill-nc", "pest-control-in-durham-nc", "pest-control-in-hillsborough-nc", "pest-control-in-morrisville-nc", "pest-control-in-raleigh-nc", "pest-control-in-wake-forest-nc", "pestcontrolinchapelhillncpage", "pestcontrolindurhamncpage", "pestcontrolinhillsboroughncpage", "pestcontrolinmorrisvillencpage", "pestcontrolinwakeforestncpage", "post", "privacy-policy", "privacypolicypage", "raleighncpestcontrolpage", "rodent-control", "rodentcontrolpage", "service-areas", "serviceareaspage", "services", "servicespage", "spider-control", "spidercontrolpage", "terms-of-service", "termsofservicepage", "wasp-control", "wasp-stinging-insect-control", "waspcontrolpage", "waspstinginginsectcontrolpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ServiceAreasPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ServiceAreasPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
